<template>
  <div
    :id="`dropdown${name}`"
    class="dropdown-select"
    :class="{
      isFocused: isOpen && !hasOneItemOnly,
      disabled: isDisabled,
      isSingle: hasOneItemOnly,
    }"
    v-click-out-side="() => $emit('onClickOutside')"
  >
    <div class="dropdown-select__container">
      <slot name="selectedItem" />

      <slot name="dropdownOptions" v-if="!hasOneItemOnly" />
    </div>

    <CaretDown :class="{ isOpen: isOpen, hidden: hideCaret }" />
  </div>
</template>

<script setup>
import { inject, computed } from "vue";
import { vClickOutSide } from "@/composables/directives/useClickOutside";
import CaretDown from "@/components/icons/CaretDown.vue";

const props = defineProps({
  name: { type: String, default: "default-select" },
  isOpen: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
  hasOneItemOnly: { type: Boolean, default: false },
});

const disableBySelectName = inject("isDisabledByKey");
const isDisabled = computed(
  () =>
    !!disableBySelectName.value &&
    Object.getOwnPropertyDescriptor(disableBySelectName.value, props.name) &&
    disableBySelectName.value[props.name]
);
const hideCaret = computed(
  () => props.hasOneItemOnly || isDisabled.value || props.isLoading
);
</script>

<style lang="scss">
.dropdown-select {
  display: flex;
  align-items: center;
  font-size: $font-input-size;
  width: 100%;
  height: 55px;
  cursor: pointer;

  @include breakpoint($min-s) {
    font-size: 2rem;
  }

  &__container {
    display: flex;
    width: 100%;
  }

  &__selected-item {
    display: flex;
    align-items: center;
  }

  .caret-down {
    margin-inline: 1rem;
    transform: rotate(0deg);
    transition: transform 250ms;
    pointer-events: none;

    &.isOpen {
      transform: rotate(180deg);
    }
  }
  &.isSingle {
    cursor: unset;
  }
}
</style>
